import React, { useState, useEffect } from "react";

const Typewriter = ({ phrases }) => {
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [currentPhrase, setCurrentPhrase] = useState("");
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    const typingInterval = setInterval(() => {
      if (isTyping) {
        if (currentPhrase === phrases[currentPhraseIndex]) {
          setIsTyping(false);
          setTimeout(() => {
            setIsTyping(true);
            setCurrentPhrase("");
            setCurrentPhraseIndex((prevIndex) =>
              prevIndex === phrases.length - 1 ? 0 : prevIndex + 1
            );
          }, 1000); // Pause for 1 second before typing the next phrase
        } else {
          setCurrentPhrase(
            phrases[currentPhraseIndex].substring(0, currentPhrase.length + 1)
          );
        }
      } else {
        clearInterval(typingInterval);
      }
    }, 80); // Typing speed (adjust as needed)

    return () => {
      clearInterval(typingInterval);
    };
  }, [currentPhrase, currentPhraseIndex, isTyping, phrases]);

  return (
    <span
      style={{
        fontSize: "1.5rem",
        fontWeight: "600",
        marginLeft: "2%",
      }}
    >
      {currentPhrase}
    </span>
  );
};

export default Typewriter;
